module.exports = __webpack_public_path__ + "img/vector.babf9e1e.png";